import Mutations from '../../odata/mutations';

export default { ...new Mutations('favourite'), ...new Mutations('favourites') };
